import React from 'react';
import UserManager from '../core/User';

export const Role = {
    KesselWorksAdmin: 'KesselWorksAdmin',
    SuperAdmin: 'SuperAdmin',
    Admin: 'Admin',
    Contributor: 'Contributor',
}

export function hasPermission(userRoles, targetRole) {
    switch (targetRole) {
        case Role.SuperAdmin:
            return userRoles.includes(Role.SuperAdmin);
        case Role.Admin:
            return userRoles.includes(Role.SuperAdmin) || userRoles.includes(Role.Admin);
        case Role.Contributor:
            return userRoles.includes(Role.SuperAdmin) || userRoles.includes(Role.Admin) || userRoles.includes(Role.Contributor);
    }
    return false;
}

/*export function RenderIfHasRole2({ minTargetRole, children }: { minTargetRole: Role | string, children?: React.ReactNode | React.ReactNode[]; }) {
    let currentUserRoles = AppStore!.currentUser!.role!;
    if (hasPermission(currentUserRoles, minTargetRole)) {
        return <>{children}</>;
    }
    return null;
}*/

export function UserRoleRenderer({ roles }) {
    const getColorClass = (role) => {
        //role = role.toLowerCase()
        if (role == Role.SuperAdmin) {
            return "badge-danger-lighten";
        }
        if (role == Role.Admin) {
            return "badge-primary-lighten";
        }
        return "badge-secondary-lighten";
    };

    if (!Array.isArray(roles)) {
        roles = [roles]
    }

    return <>{roles.map((role) => <div key={role} className={'badge fw-bolder me-1 ' + getColorClass(role)}>{role}</div>)}</>
}

// minTargetRole
export class RenderIfHasRole extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!UserManager.getUserDetailsSync()) {
            return;
        }
        const currentUserRoles = UserManager.getUserDetailsSync().role;
        if (hasPermission(currentUserRoles, this.props.minTargetRole)) {
            return <React.Fragment>{this.props.children}</React.Fragment>;
        }
        return null;
    }
}